var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',[_c('v-btn',{staticClass:"my-3 p-2 folderBtn",attrs:{"block":""},on:{"click":function($event){return _vm.clickHandler()}}},[_vm._v(" "+_vm._s(_vm.text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }